import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import useValueLabels from '../hooks/useValueLabels';
import { FileVisibilityBadge } from './FileVisibility';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const slug = (c) => `cat-${c.replace(/\s+/g, '-').toLowerCase()}`;

/** Admin: default "who can see" per document type; pre-filled on upload. */
export const CategoryVisibilityDefaults = () => {
  const { t } = useTranslation();
  const vl = useValueLabels();
  const [categories, setCategories] = useState([]);
  const [defaults, setDefaults] = useState({});

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => {
      setCategories(r.data?.attachment_categories || []);
      setDefaults(r.data?.attachment_category_visibility || {});
    }).catch(() => {});
  }, []);

  const save = async (cat, v) => {
    const next = { ...defaults, [cat]: { all: v.all, roles: v.all ? [] : v.roles } };
    try {
      const r = await axios.put(`${API}/attachments/category-defaults`, next);
      setDefaults(r.data);
      toast.success(t('fileVisibility.defaultsSaved'));
    } catch (e) {
      toast.error(e.response?.data?.detail || t('fileVisibility.defaultsSaveFailed'));
    }
  };

  return (
    <Card data-testid="category-visibility-defaults">
      <CardHeader>
        <CardTitle className="text-base">{t('fileVisibility.defaultsTitle')}</CardTitle>
        <CardDescription>{t('fileVisibility.defaultsDesc')}</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {categories.map((c) => {
          const d = defaults[c];
          const att = { id: slug(c), visible_to_all: !d || d.all !== false, visible_roles: d?.roles || [], can_edit_visibility: true };
          return (
            <div key={c} className="flex items-center justify-between gap-2 rounded-md border px-3 py-2" data-testid={`category-default-row-${slug(c)}`}>
              <span className="text-sm truncate">{vl(c)}</span>
              <FileVisibilityBadge attachment={att} onSave={(_, v) => save(c, v)} />
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
